import { ApolloClient, from } from '@apollo/client';
import {
  authLink,
  buildAuthErrorLink,
  createUploadHttpLink,
  userCountryLink,
  getApolloDevtoolsOptions,
} from '@blocs.auth';
import cache from './cache';

const createApolloClient = (): ApolloClient<any> => {
  return new ApolloClient({
    link: from([buildAuthErrorLink({}), userCountryLink, authLink, createUploadHttpLink()]),
    cache,
    name: 'web',
    version: 'casting',
    devtools: getApolloDevtoolsOptions(),
  });
};

export default createApolloClient;
